export default class {
	constructor() {
		this.footer = document.querySelector(".site-footer");

		if (!this.footer) {
			return;
		}

		this.headings = this.footer.querySelectorAll(".widget_nav_menu h3");

		if (!this.headings) {
			return;
		}

		for (const item of this.headings) {
			item.addEventListener("click", this.handleClick.bind(this));

			const menuWrap = item.parentNode.querySelector("h3 + div");

			if (menuWrap) {
				menuWrap.style.height = `${menuWrap.scrollHeight}px`;
			}
		}
	}

	handleClick(e) {
		if ("pointer" !== window.getComputedStyle(e.target).cursor) {
			return;
		}

		e.preventDefault();

		e.target.closest(".widget_nav_menu").classList.toggle("is-open");
	}
}
